import { render } from "./FeedbackChartsDays.vue?vue&type=template&id=8a201ef0&scoped=true&ts=true"
import script from "./FeedbackChartsDays.vue?vue&type=script&lang=ts"
export * from "./FeedbackChartsDays.vue?vue&type=script&lang=ts"

import "./FeedbackChartsDays.vue?vue&type=style&index=0&id=8a201ef0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a201ef0"]])

export default __exports__